import JsApi from '@tencent/tvf-jsapi';
import { LauncherFactory } from '@tencent/athena-applauncher';
import { OpenPageConfig } from '../types/open-page';
import { iosVideoPlugin } from './plugins/ios-video';
import { isTenvideo } from '../env';

// 腾讯视频外部引流的渠道统计，分配给爱玩业务默认为30158
export const IWAN_DEFAULT_VIDEO_FROM = 30158;

// 是否为腾讯视频伪协议链接格式
export const isVideoScheme = (link: string): boolean => /^(txvideo:\/\/)|(tenvideo2:\/\/)/.test(link);

// 打开页面方法
export const openPage = async (linkParam: string, config?: OpenPageConfig) => {
  let link = linkParam;
  const pluginArr = [
    ...(config?.linkHandlePlugin || []),
    ...(config?.h5ForceOpenUrl ? [] : [iosVideoPlugin]),
  ];
  for (const handleFunc of pluginArr) {
    link = await handleFunc(link);
  }

  if (isVideoScheme(link)) {
    if (isTenvideo()) {
      return JsApi.invoke('openView', {
        url: link,
        close: config?.close,
      });
    }
    const launcher = LauncherFactory.createTenVideoLauncher({
      model: {
        confid: config?.videoFrom || IWAN_DEFAULT_VIDEO_FROM, // 渠道号填这里
      },
    });
    return launcher.tryOpen({
      path: link,
    });
  }

  return JsApi.invoke('openUrl', {
    url: link,
    close: config?.close,
  });
};
